module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ux-onboarding-Artboard-7@2x.7c794ffb.png";